import type { TherapyType } from "../../api-client";

const scopes = {
  therapiesAdmin: "therapiesAdmin",
  prices: "prices",
  diagnosisGroupsAdmin: "diagnosisGroupsAdmin",
  therapyCertifications: "therapyCertifications",
  tarifGroups: "tarifGroups",
  rxTypes: "rxTypes",
  catalogTerms: "catalogTerms",
  catalogMethods: "catalogMethods",
  catalogGraph: "catalogGraph",
};

export const TherapiesKeys = {
  therapies: {
    scope: scopes.therapiesAdmin,
    all: (therapyType?: TherapyType) =>
      therapyType
        ? ([scopes.therapiesAdmin, { therapyType }] as const)
        : ([scopes.therapiesAdmin] as const),
    byId: (id: string) => [scopes.therapiesAdmin, id] as const,
    usage: (id: string) => [scopes.therapiesAdmin, id, "usage"] as const,
  },
  prices: {
    scope: scopes.prices,
    all: () => [scopes.prices] as const,
    forTherapy: (therapyId: string) => [scopes.prices, { therapyId }] as const,
    usage: (id: string) => [scopes.prices, id, "usage"] as const,
  },
  diagnosisGroups: {
    scope: scopes.diagnosisGroupsAdmin,
    all: (therapyType?: TherapyType) =>
      therapyType
        ? ([scopes.diagnosisGroupsAdmin, { therapyType }] as const)
        : ([scopes.diagnosisGroupsAdmin] as const),
    usage: (id: string) => [scopes.diagnosisGroupsAdmin, id, "usage"] as const,
  },
  therapyCertifications: {
    scope: scopes.therapyCertifications,
    all: () => [scopes.therapyCertifications] as const,
  },
  tarifGroups: {
    scope: scopes.tarifGroups,
    all: () => [scopes.tarifGroups] as const,
  },
  rxTypes: {
    scope: scopes.rxTypes,
    all: () => [scopes.rxTypes] as const,
  },
  catalogTerms: {
    scope: scopes.catalogTerms,
    all: (therapyType?: TherapyType) =>
      therapyType
        ? ([scopes.catalogTerms, { therapyType }] as const)
        : ([scopes.catalogTerms] as const),
    usage: (id: string) => [scopes.catalogTerms, id, "usage"] as const,
  },
  catalogMethods: {
    scope: scopes.catalogMethods,
    all: (therapyType?: TherapyType) =>
      therapyType
        ? ([scopes.catalogMethods, { therapyType }] as const)
        : ([scopes.catalogMethods] as const),
    usage: (id: string) => [scopes.catalogMethods, id, "usage"] as const,
  },
  catalogGraph: {
    scope: scopes.catalogGraph,
    all: (therapyType?: TherapyType) =>
      therapyType
        ? ([scopes.catalogGraph, { therapyType }] as const)
        : ([scopes.catalogGraph] as const),
  },
};
